import yup from '@/infra/YupDecorator';
import { formatCurrency } from '@/Utils/FnUtils';

export const postPaidLimitSchema = yup.object({
  postPaidLimit: yup
    .string()
    .required('O limite do pós pago é obrigatório')
    .test('positive-value', 'O valor deve ser positivo', value => {
      if (!value) return true;
      const numericValue = parseFloat(value.replace(',', '.'));
      return !isNaN(numericValue) && numericValue > 0;
    })
    .test('min-allowed', function minAllowed(value) {
      const minAllowed = this.options.context?.minAllowed;

      if (!value) return true;

      const stringWithoutDots = value.replace(/\./g, '');
      const stringWithDecimalPoint = stringWithoutDots.replace(',', '.');
      const numericValue = Math.round(Number(stringWithDecimalPoint));
      const isValid = !isNaN(numericValue) && numericValue >= minAllowed;

      if (!isValid) {
        return this.createError({
          message: `O limite mensal não pode ser menor que ${formatCurrency(
            minAllowed,
          )}`,
        });
      }

      return true;
    })
    .test('max-allowed', function maxAllowed(value) {
      const maxAllowed = this.options.context?.maxAllowed;

      if (!value) return true;

      const stringWithoutDots = value.replace(/\./g, '');
      const stringWithDecimalPoint = stringWithoutDots.replace(',', '.');
      const numericValue = Math.round(Number(stringWithDecimalPoint));
      const isValid = !isNaN(numericValue) && numericValue <= maxAllowed;

      if (!isValid) {
        return this.createError({
          message: `O limite mensal não pode ser maior que ${formatCurrency(
            maxAllowed,
          )}`,
        });
      }

      return true;
    }),
});
